import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import MainLayout from './layouts/MainLayout';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import RegistrationPage from './pages/RegistrationPage';
import FaqPage from './pages/FaqPage';
import PartnersPage from './pages/PartnersPage';
import ContactsPage from './pages/ContactsPage';
import ParticipantsPage from './pages/ParticipantsPage';
import BlogPage from './pages/BlogPage';
import BlogPostPage from './pages/BlogPostPage';
import NotFoundPage from './pages/NotFoundPage';
import AdminApplicationsPage from './pages/AdminApplicationsPage';
import MetrikaPageTracker from './components/MetrikaPageTracker';

function App() {
  return (
    <Router>
      <MetrikaPageTracker />
      <Routes>
        <Route path="/" element={<MainLayout><HomePage /></MainLayout>} />
        <Route path="/about" element={<MainLayout><AboutPage /></MainLayout>} />
        <Route path="/participants" element={<MainLayout><ParticipantsPage /></MainLayout>} />
        <Route path="/registration" element={<MainLayout><RegistrationPage /></MainLayout>} />
        <Route path="/faq" element={<MainLayout><FaqPage /></MainLayout>} />
        <Route path="/partners" element={<MainLayout><PartnersPage /></MainLayout>} />
        <Route path="/contacts" element={<MainLayout><ContactsPage /></MainLayout>} />
        <Route path="/blog" element={<MainLayout><BlogPage /></MainLayout>} />
        <Route path="/blog/:slug" element={<MainLayout><BlogPostPage /></MainLayout>} />
        {/* Заглушки для будущих страниц */}
        <Route path="/login" element={<MainLayout><div>Страница входа (в разработке)</div></MainLayout>} />
        <Route path="/dashboard" element={<MainLayout><div>Личный кабинет (в разработке)</div></MainLayout>} />
        <Route path="/admin" element={<MainLayout><AdminApplicationsPage /></MainLayout>} />
        <Route path="*" element={<MainLayout><NotFoundPage /></MainLayout>} />
      </Routes>
    </Router>
  );
}

export default App;